import React from "react";
import {
  Container,
  Typography,
  Link,
  ThemeProvider,
  createTheme,
  List,
  ListItem,
  ListItemText,
  Card,
  CardMedia,
  Breadcrumbs,
  CardHeader,
  CardContent,
} from "@material-ui/core";
import { Link as RouterLink, useParams } from "react-router-dom";
import getIcon from "../iconMapping";
import ProjectDetails from "./ProjectDetailsBox";

const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const getProjectImagePath = (project, imageName) =>
  `${process.env.PUBLIC_URL}/projectAssets/${project.assetDirectory}/${imageName}`;

function ProjectDetailPage({ projects }) {
  const { projectSlug } = useParams();
  const project = projects.find((entry) => entry.slug === projectSlug);

  if (!project) {
    return (
      <Container style={{ margin: "auto", maxWidth: "960px" }}>
        <Typography variant="h4" gutterBottom>
          Project not found
        </Typography>
        <Typography color="textSecondary">
          The requested project does not exist in the current portfolio data.
        </Typography>
      </Container>
    );
  }

  const imageUrl = getProjectImagePath(project, project.images.banner);
  const detailDescription =
    project.project_details.description || project.description;
  const ExternalLinkIcon = getIcon("externalLink");

  return (
    <ThemeProvider theme={theme}>
      <Container style={{ margin: "auto", maxWidth: "1280px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" component={RouterLink} to="/projects">
            Projects
          </Link>
          <Typography color="textPrimary">{project.name}</Typography>
        </Breadcrumbs>
        <Typography variant="h2" style={{ marginBottom: "1.2rem" }}>
          {project.name}
          {ExternalLinkIcon && project.link ? (
            <Link href={project.link} target="_blank" rel="noopener noreferrer">
              <ExternalLinkIcon
                style={{
                  fontSize: "small",
                  verticalAlign: "top",
                  marginTop: ".5rem",
                }}
              />
            </Link>
          ) : null}
        </Typography>
        <Card style={{ margin: "20px 0  20px 0", borderRadius: "10px" }}>
          <CardMedia
            component="img"
            alt={project.name}
            image={imageUrl}
            style={{
              maxHeight: "400px",
              width: "100%",
              height: "auto",
            }}
          />
        </Card>
        <br />
        <div style={{ display: "flex", gap: "20px", margin: "20px" }}>
          <Card style={{ flex: 2, overflow: "hidden", borderRadius: "5px" }}>
            <CardHeader title="Description" />
            <CardContent>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                style={{ whiteSpace: "pre-line" }}
              >
                {detailDescription}
              </Typography>
            </CardContent>
          </Card>
          <ProjectDetails project={project} />
        </div>
        {project.sections.length > 0 ? (
          <>
            <Typography variant="h6" gutterBottom>
              Sections
            </Typography>
            <List>
              {project.sections.map((section, index) => (
                <ListItem key={`${project.slug}-section-${index}`}>
                  <ListItemText primary={section.name || section.description} />
                </ListItem>
              ))}
            </List>
          </>
        ) : null}
        <Typography
          variant="body1"
          gutterBottom
          style={{ whiteSpace: "pre-line" }}
        >
          {project.description}
        </Typography>
        <Typography variant="h6" gutterBottom>
          Points:
        </Typography>
        <List>
          {project.points.map((point) => (
            <ListItem key={point}>
              <ListItemText primary={`- ${point}`} />
            </ListItem>
          ))}
        </List>
      </Container>
    </ThemeProvider>
  );
}

export default ProjectDetailPage;
